const initializeGACookie = () => {
  const expiresHours = 1; // Expires after 1 hour
  const date = new Date(Date.now() + (expiresHours * 60 * 60 * 1000));
  const gaId = ga.getAll()[0].get('clientId');
  const domain = document.body.getAttribute("data-domain");
  tc.dom.setCookie("ga_identifier", gaId, { domain, expires: date });
};

window.addEventListener("load", () => {
  if (window.ga && ga.create) {
    initializeGACookie();
  } else {
    console.log("Google Analytics is not found on the page.");
  }
});
